import { IncentiveSlots } from "./BaseTemplate";
import { IncentiveStep } from '../../../../interfaces/enums/incentive-step';
import type { IAnonymousStudentService } from "@studyportals/anonymous-student-interfaces";
import type { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { computed, type Ref, ref } from 'vue';
import { AnonymousStudentProfileSynced, AnonymousStudentServiceReady } from "@studyportals/anonymous-student-interfaces";
import { ISubscriber } from "@studyportals/event-aggregation-service-interface";
import { IStudent, StudentField } from '@studyportals/studentdomain';
import globals from "@/utils/globals";

export default class BaseTemplate implements ISubscriber<AnonymousStudentServiceReady | AnonymousStudentProfileSynced> {
	incentiveStep = computed((): typeof IncentiveStep => {
		return IncentiveStep;
	});

	step = computed(() => {
		return this.store.getters.step();
	});
	anonymousStudentService: Ref<IAnonymousStudentService | null> = ref(null);

	constructor(
		public store: IIncentiveV2Store,
		public steps: IncentiveStep[],
		public slots: IncentiveSlots,
		public isRegister: Ref<boolean>,
		public isForgotPassword: Ref<boolean> = ref(false),
	) {
		globals.eventAggregationService?.subscribeTo(AnonymousStudentServiceReady.EventType, this, true);
		globals.eventAggregationService?.subscribeTo(AnonymousStudentProfileSynced.EventType, this, true);
	}

	notify(event: AnonymousStudentProfileSynced | AnonymousStudentServiceReady): void {
		if (event.eventType === AnonymousStudentServiceReady.EventType) {
			this.anonymousStudentService.value = (event as AnonymousStudentServiceReady).anonymousStudentService;
			void this.showOptInStep();

			return;
		}

		void this.showOptInStep();
	}

	async showOptInStep(): Promise<void> {
		if (!globals.isLoggedIn.value) return;

		const studentData = await this.anonymousStudentService.value?.getStudentData([
			StudentField.IDENTITY_ID,
			StudentField.EMAILING_FAVOURITES,
			StudentField.EMAILING_OTHER,
			StudentField.EMAILING_SCHOLARSHIPS,
			StudentField.EMAILING_UPDATES
		]);

		if (!studentData) return Promise.resolve();

		const allEmailPreferencesEnabled = this.checkIfUserHasAllEmailingPreferences(studentData);

		if (allEmailPreferencesEnabled) {
			this.store.actions.setNextStep(IncentiveStep.OPT_IN, IncentiveStep.CPI);
			return;
		}

		this.store.mutations.setStep(this.incentiveStep.value.OPT_IN);
	}

	checkIfUserHasAllEmailingPreferences(studentData: IStudent): boolean {
		return Boolean(
			studentData[StudentField.EMAILING_FAVOURITES] &&
			studentData[StudentField.EMAILING_OTHER] &&
			studentData[StudentField.EMAILING_SCHOLARSHIPS] &&
			studentData[StudentField.EMAILING_UPDATES]
		);
	}
}